<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/qBTC.svg'), class: 'full-logo', name: 'qBTC', url: 'https://qb.tc/' },
      { logo: require('@/assets/logos/maelstrom.svg'), class: 'full-logo', name: 'Maelstrom', url: 'https://maelstrom.fund/' },
      { logo: require('@/assets/logos/blueprint.png'), class: 'full-logo', name: 'Blueprint', url: 'https://blueprint.bryanjohnson.com/' },
      { logo: require('@/assets/logos/cryptoknights.png'), class: 'full-logo', name: 'CryptoKnights', url: 'https://www.cryptoknights.tv/' },
      { logo: require('@/assets/logos/bittensor.svg'), class: 'full-logo', name: 'Bittensor', url: 'https://www.bittensor.ai/subnets/17' },
      { logo: require('@/assets/logos/leadpoet.svg'), class: 'full-logo', name: 'Leadpoet', url: 'https://www.leadpoet.com/' },
      { logo: require('@/assets/logos/rizzo.svg'), class: 'logo', name: 'Rizzo Network', url: 'https://rizzo.network/' },
      { logo: require('@/assets/logos/silentswap.svg'), class: 'full-logo', name: 'Silent Swap', url: 'https://www.silentswap.com/' },
      { logo: require('@/assets/logos/iohk.png'), class: 'full-logo', name: 'Input Output', url: 'https://iohk.io/' },
      { logo: require('@/assets/logos/casa.svg'), class: 'logo', name: 'Casa', url: 'http://casa.io/' },
      { logo: require('@/assets/logos/btlabs.png'), class: 'full-logo', name: 'BtLabs', url: 'https://btlabs.ai/' },
      { logo: require('@/assets/logos/ceti.png'), class: 'logo', name: 'Ceti', url: 'https://taoceti.ai/' },
      { logo: require('@/assets/logos/Y.png'), class: 'logo libera', name: 'Yanez Compliance', url: 'https://www.yanezcompliance.com/' },
      { logo: require('@/assets/logos/hydrahost.png'), class: 'full-logo', name: 'HydraHost', url: 'https://hydrahost.com/' },
      { logo: require('@/assets/logos/backstage.svg'), class: 'full-logo', name: 'Backstage', url: 'https://backstage.global/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/logos/inbestgo.svg'), class: 'full-logo', name: 'Inbestgo', url: 'https://inbestgo.com/' },
      { logo: require('@/assets/logos/estatex.png'), class: 'full-logo', name: 'EstateX', url: 'https://www.estatex.eu/' },
      { logo: require('@/assets/logos/monoquant.svg'), class: 'logo wolf', name: 'Monoquant', url: 'https://www.monoquant.com/' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/singapore/sponsors/bos.png'), class: 'logo', name: 'BitcoinOS', url: 'https://www.bitcoinos.build/' },
      { logo: require('@/assets/nashville/sponsors/quai.png'), class: 'full-logo', name: 'Quai Network', url: 'https://qu.ai/' },
      { logo: require('@/assets/logos/pentagon.png'), class: 'full-logo', name: 'Pentagon Games', url: 'https://pentagon.games/' },
      { logo: require('@/assets/nashville/sponsors/kredete.png'), class: 'full-logo', name: 'Kredete', url: 'https://www.kredete.com/' },
      { logo: require('@/assets/logos/zkalyx.png'), class: 'full-logo', name: 'Zkalyx', url: 'https://www.zkalyx.com/' },
      { logo: require('@/assets/logos/matterfi.svg'), class: 'full-logo', name: 'MatterFi', url: 'https://www.matterfi.com/' },
      { logo: require('@/assets/nashville/sponsors/chintai.png'), class: 'full-logo', name: 'Chintai', url: 'https://chintai.io/' },
    ]);
    return {
      partners
    };
  },
};
</script>